import React from 'react';
import { Typography, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Shared header title: "Helios" on home, "Helios Security Questions" on questionnaire,
 * "Helios Contract Review" on contract-review. Clicking redirects to homepage.
 */
const HeliosTitle: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = () => {
    navigate('/');
  };

  const suffix =
    pathname.startsWith('/questionnaire')
      ? 'Security Questions'
      : pathname.startsWith('/contract-review')
        ? 'Contract Review'
        : null;

  return (
    <Box 
      onClick={handleClick}
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.25,
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8,
        },
      }}
    >
      <img 
        src="/favicon.ico" 
        alt="OneSec Logo"
        style={{ width: 28, height: 28, objectFit: 'contain' }}
      />
      <Typography
        sx={{
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '31px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <span style={{ color: '#47A1AD' }}>OneSec</span>
        {suffix !== null && <span style={{ color: '#000000' }}>{suffix}</span>}
      </Typography>
    </Box>
  );
};

export default HeliosTitle;
